const htmlCharacters = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;",
};

export function escapeHtml(value) {
  return String(value ?? "").replace(
    /[&<>"']/g,
    (character) => htmlCharacters[character],
  );
}

export function getWorkCardLayout(index, providedLayout = "") {
  if (providedLayout === "portrait" || providedLayout === "landscape") {
    return providedLayout;
  }

  return [0, 7].includes(index % 12) ? "portrait" : "landscape";
}

export function getNewsCardLayout(index, providedLayout = "") {
  if (providedLayout === "portrait" || providedLayout === "horizontal") {
    return providedLayout;
  }

  return [0, 4].includes(index % 6) ? "portrait" : "horizontal";
}
